import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { IzinPreviewComponent } from 'src/app/izin/izin-preview/izin-preview.component';
import { PreviewMapComponent } from 'src/app/kehadiran-detail/preview-map/preview-map.component';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';

@Component({
  selector: 'app-detail-performance-col',
  templateUrl: './detail-performance-col.component.html',
  styleUrls: ['./detail-performance-col.component.css']
})
export class DetailPerformanceColComponent implements OnInit {

  
    kw: any;
    load: boolean = false;
    hasilX: any = {};
  
    cabang: any = '';
    surveyor: any = '';
  nama: any = '';
  aa: any = [];
  status: any = '';
  is_forever: boolean = false;
  is_foreverText: string = 'N';
  datax: any = []
  type: any = '';
  
    constructor(
      public navParams: NavParams,
      public api: ApiService,
      public util: UtilService,
      public modalController: ModalController,
    ) { 
      try {
        this.datax = JSON.parse(this.navParams.data.datax);
        console.log('KW', this.datax);
        this.type = this.navParams.data.type;
      } catch (error) {
        console.log(error)
        // this.util.showToast('Data Lead_id tidak terparsing', 'danger', 'bottom');
      }
    }
  
    ngOnInit(): void {
  
    }
  
    batal(){
      this.api.dismiss();
    }

    async lihat(id: any) {
        const modal = await this.modalController.create({
          component: IzinPreviewComponent,
          cssClass: 'modalPreviewImage',
          componentProps: {
            id: id
          }
        });
        modal.onDidDismiss()
          .then((data: any) => {
            if (data.role === 'confirm') {
              // this.ionViewWillEnter();
            }
          });
        return await modal.present();
      }
  
    async prevMap(latlong: any) {
        const [lat, lng] = latlong.split(',');

      let id = {
        latitude: lat,
        longitude: lng
      };
      const modal = await this.modalController.create({
        component: PreviewMapComponent,
        cssClass: 'modalMaps',
        componentProps: {
          id: id
        }
      });
      modal.onDidDismiss()
        .then((data: any) => {
          if (data.role === 'confirm') {
            // this.ionViewWillEnter();
          }
        });
      return await modal.present();
    }
  
  
  }
  